function setPlatName (platName) {
  if (platName) {
    document.title = platName
  }
}

const profile = {
  state: {
    name: '',
    legend: ''
  },
  mutations: {
    setProfile (state, {name, legend}) {
      state.name = name
      state.legend = legend
      setPlatName(legend)
    }
  }
}

export default profile
